import { useEffect, useState } from 'react';
import { isString } from 'lodash-es';
import { getWithdrawalWalletList } from '../../api/cryptocurrencies';
import { WithdrawalWallet } from '../../api/cryptocurrencies/types';
import { STORE_PROPS, usePaymentsStore } from '../../store';
import { getKeyByServiceId } from '../../utils/getKeyByServiceId';

const { ACTIVE_SERVICE_ID } = STORE_PROPS;

const CRYPTO_API_CONFIG = {
  E_EX_WALLET_CRYPTO: { prefix: 'eexwallet' },
  COINSPAID: { prefix: 'coins-paid', version: 'v2' }
};

export const useGetWithdrawalWalletList = (cryptoCurrency: string) => {
  const [addressList, setAddressList] = useState<WithdrawalWallet[]>([]);
  const activeServiceId = usePaymentsStore(ACTIVE_SERVICE_ID);
  const keyByServiceId = getKeyByServiceId(activeServiceId as number);
  const apiConfig =
    CRYPTO_API_CONFIG[keyByServiceId as keyof typeof CRYPTO_API_CONFIG];
  useEffect(() => {
    (async () => {
      try {
        const addressListResponse = await getWithdrawalWalletList(apiConfig, {
          cryptoCurrency
        });
        setAddressList(addressListResponse || []);
      } catch (e) {
        console.error(e);
      }
    })();
  }, [cryptoCurrency]);

  // For CoinsPaid ps list of crypto addresses comes as a list of strings
  // while for Eexwallet ps it's a list of objects.
  // the following expression unifies the result and align it to common format { cryptoAddress: 'address_string' }
  // temporal solution till realise of v2 endpoint version
  return isString(addressList[0])
    ? addressList.map((item) => ({ cryptoAddress: item }))
    : addressList;
};
